import { useContext, useEffect, useState } from 'react';
import UIModal from './UIModal';
import UserContext from '../../context/UserContext';
import isArtist from '../../utils/isArtist';
import Button from '../Button';
import isAdmin from '../../utils/isAdmin';

export default function SunsetOnlinePaymentModal() {
	const [isOpen, setIsOpen] = useState(false);
	const { user } = useContext(UserContext);

	useEffect(() => {
		if (
			user &&
			(isAdmin(user) || isArtist(user)) &&
			localStorage.getItem('sunset-online-payment-modal-dismissed') !== 'true'
		) {
			setIsOpen(true);
		}
	}, [user]);

	if (!isOpen) return null;

	return (
		<UIModal
			name="sunset-online-payment"
			className="max-w-full lg:max-w-lg py-6 px-10"
			onRequestClose={() => setIsOpen(false)}
			containerClassName="px-2"
			closeOnContainerClick={true}
		>
			<p className="text-center text-[70px]">😔</p>
			<div className="flex flex-col gap-4 mt-4 italic">
				<p>Dragi utilizatori,</p>
				<p>
					Din cauza costurilor ridicate de contabilitate,{' '}
					<b>am decis să suspendăm plățile online</b> pe platforma noastră. Veți putea în continuare
					să primiți comenzi cu plata ramburs.
				</p>
				<p>
					Ne cerem scuze pentru inconvenient și vă mulțumim pentru înțelegere. Vom căuta alternative
					mai bune și vă vom informa imediat.
				</p>
				<p>Pentru întrebări, ne puteți contacta la contact@customstudio.ro</p>
				<p>
					Mulțumim,
					<br />
					Echipa CustomStudio
				</p>
			</div>
			<Button
				containerClassName="block primary mt-7 mx-auto"
				onClick={() => {
					setIsOpen(false);
					localStorage.setItem('sunset-online-payment-modal-dismissed', 'true');
				}}
				text="Am înțeles"
			/>
		</UIModal>
	);
}
